import { Reveal, Eyebrow } from "./Reveal";
import { MaintenanceForm } from "./MaintenanceForm";
import { Options } from "./Options";
import { PricingCard, MaintenanceOffer } from "./PricingCard";
import { useCheckout } from "../hooks/useCheckout";

const TIERS = [
  {
    id: "starter",
    name: "Starter",
    tagline: "Site vitrine simple & clé en main",
    price: "450 €",
    lookup: "site_starter_once",
    badge: "Lancement rapide",
    popular: false,
    features: [
      "1 page moderne responsive (One-Page haut de gamme)",
      "Présentation de votre activité & de vos services",
      "Formulaire de contact + bouton d'appel rapide",
      "Intégration de vos photos & coordonnées",
      "Optimisé pour smartphones et tablettes",
      "Livraison sous 5 jours ouvrés",
    ],
    cta: "Choisir la formule Starter",
  },
  {
    id: "pro",
    name: "Pro",
    tagline: "5 à 6 pages + blog intégré",
    price: "700 €",
    lookup: "site_pro_once",
    badge: "Le plus choisi",
    popular: true,
    features: [
      "5 à 6 pages personnalisées (Accueil, Services, À propos, Blog, Contact)",
      "Module de blog / actualités pour faire vivre votre site",
      "Optimisation SEO locale (Google Maps & référencement)",
      "Galerie de réalisations / photos HD interactive",
      "Formulaire sur-mesure + stockage des demandes",
      "Formation express pour modifier vos textes facilement",
      "Livraison sous 10 jours ouvrés",
    ],
    cta: "Obtenir l'offre Pro",
  },
  {
    id: "premium",
    name: "Premium",
    tagline: "Sur-mesure + SEO avancé + maintenance",
    price: "950 €",
    lookup: "site_premium_once",
    badge: "Performance tout-inclus",
    popular: false,
    features: [
      "Design 100% sur-mesure aux couleurs de votre marque",
      "Structure multi-pages illimitée / catalogue produits",
      "Stratégie SEO complète (mots-clés + balisage technique)",
      "Maintenance technique & mises à jour offertes 6 mois",
      "Statistiques de visites & rapport mensuel",
      "Support prioritaire 7j/7 par téléphone et email",
      "Livraison sur-mesure personnalisée",
    ],
    cta: "Démarrer le projet Premium",
  },
];

export const Pricing = ({ onSelect }) => {
  const { loadingId, checkout } = useCheckout();

  return (
  <section id="offres" className="border-y border-navy/10 bg-white py-16 sm:py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-2xl text-center">
        <Reveal>
          <Eyebrow><span className="mx-auto">Les offres</span></Eyebrow>
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="mt-5 font-display text-2xl font-bold tracking-tight text-navy sm:text-3xl lg:text-4xl">
            Trois formules, zéro surprise.
          </h2>
        </Reveal>
        <Reveal delay={0.16}>
          <p className="mt-4 text-base leading-relaxed text-slate-600">
            Un prix ferme, tout compris : la création, la mise en ligne et l'accompagnement.
            Chaque projet est unique, le devis reste gratuit.
          </p>
        </Reveal>
      </div>

      <div className="mt-14 grid grid-cols-1 items-stretch gap-6 lg:grid-cols-3 lg:gap-8">
        {TIERS.map((t, i) => (
          <Reveal key={t.id} delay={i * 0.1} className="h-full">
            <PricingCard
              tier={t}
              loading={loadingId === t.id}
              onCheckout={() => checkout(t.id, t.lookup)}
              onQuote={() => onSelect(t.name)}
            />
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.15}>
        <MaintenanceOffer loading={loadingId === "care"} onCheckout={() => checkout("care", "care_monthly")} />
      </Reveal>

      <MaintenanceForm />

      <Options />

      <Reveal delay={0.2}>
        <p className="mt-10 text-center text-sm text-slate-500" data-testid="pricing-note">
          Paiement sécurisé par Stripe — prix nets, sans frais caché, devis confirmé avant tout démarrage.
        </p>
      </Reveal>
    </div>
  </section>
  );
};
